import { render, staticRenderFns } from "./contractSettings.vue?vue&type=template&id=2199a29e&scoped=true"
import script from "./contractSettings.vue?vue&type=script&lang=js"
export * from "./contractSettings.vue?vue&type=script&lang=js"
import style0 from "./contractSettings.vue?vue&type=style&index=0&id=2199a29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199a29e",
  null
  
)

export default component.exports